import type { Session } from '../types/session';

type LicenseSession = Pick<Session, 'status' | 'expiredAt' | 'demo' | 'modules'>;

function isFutureDate(value: unknown, now = Date.now()): boolean {
  if (typeof value !== 'string' || value.trim().length === 0) return false;
  const timestamp = Date.parse(value);
  return Number.isFinite(timestamp) && timestamp > now;
}

function hasActiveAccount(session: LicenseSession | null | undefined): boolean {
  return session?.status === 'active';
}

/**
 * Ações premium falham fechadas: data ausente, inválida, vencida ou igual ao instante atual
 * não representa uma licença. Leitura/exportação/backup não usam esta função.
 */
export function hasActiveMainLicense(
  session: LicenseSession | null | undefined,
  now = Date.now(),
): boolean {
  return hasActiveAccount(session) && isFutureDate(session?.expiredAt, now);
}

/** Demonstração preserva a exceção histórica de captura, mas nunca ignora conta inativa. */
export function canStartCapture(
  session: LicenseSession | null | undefined,
  now = Date.now(),
): boolean {
  return hasActiveAccount(session) && (session?.demo === true || isFutureDate(session?.expiredAt, now));
}

/** Enriquecimento e semelhantes exigem licença principal paga e válida. */
export function canUsePaidFeature(
  session: LicenseSession | null | undefined,
  now = Date.now(),
): boolean {
  return session?.demo !== true && hasActiveMainLicense(session, now);
}

/** LeadExplorer exige simultaneamente a licença principal e sua data própria futura. */
export function canUseLeadExplorer(
  session: LicenseSession | null | undefined,
  now = Date.now(),
): boolean {
  return (
    canUsePaidFeature(session, now) &&
    isFutureDate(session?.modules?.leadexplorer, now)
  );
}
